import definitions from "../../../definitions";
import QuestMinigame from "../QuestMinigame";

export default class MinigameChickenRun extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._chickenType = null;
        this._spawnTime = 0;
        this._spawnDelay = 0;

        this._npc = null;
        this._allChickens = [];

        this._holdingChicken = null;
        this._pen = null;

        this._player = null;

        this._repressEnemyChase = true;

        this.coins = 1;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._chickenType = metadata.chickenType;
        this._spawnDelay = Math.max(metadata.spawnDelay);
        this._spawnLimit = Math.max(metadata.spawnLimit);
        this._penRect = metadata.penRect;
        this._depositRect = metadata.depositRect;
        this.coins = metadata.coins;
    }

    /**
     * @param {GameScene} game
     */
    spawnChicken(game) {
        //console.log('spawnChicken');
        const position = game.world.findSafePosition({x:this._pen.x + (this._pen.width/2), y:this._pen.y + (this._pen.height/2)}, 180, 160, 20, [], 10);
        const chicken = game.createEnemy(this._chickenType, position, false, false);
        chicken.target = game.player;
        chicken.state = definitions.ENEMY_STATE.RETREAT;
        chicken.signals.grabbed.add(this.onChickenGrabbed, this);
        
        this._allChickens.push(chicken);
    }

    /**
     * @param {GameScene} game
     */
    removeAllChickens(game) {
        for (let i = 0, count = this._allChickens.length; i < count; ++i) {
            const enemy = this._allChickens[i];
            game.removeEnemy(enemy);
        }
    }

    /**
     * @param {Enemy} enemy
     */
    onChickenGrabbed(chicken) {
        if (this._holdingChicken != null || chicken.state != definitions.ENEMY_STATE.RETREAT)
            return;
        
        //chicken.interactable = false;
        this._holdingChicken = chicken;
        chicken.state = definitions.ENEMY_STATE.CAPTURE;
        this._holdingChicken.collisionEnabled = this._holdingChicken.collisionDynamic = false;
        this._player.holdingObject = true;
        this._holdingChicken.view.x = this._player.holdingOffset.x;
        this._holdingChicken.view.y = this._player.holdingOffset.y;
        this._player.addChild(this._holdingChicken.view);
        this._player.addChild(this._player.view);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        if(this.isRunning)
            return;

        super.onMinigameStart(game);

        this._player = game.player;

        this._npc = game.findNPC(this.owner);

        this._deposit = new PIXI.Rectangle(this._npc.position.x + this._depositRect.x, this._npc.position.y + this._depositRect.y, this._depositRect.width, this._depositRect.height);
        this._pen = new PIXI.Rectangle(this._npc.position.x + this._penRect.x, this._npc.position.y + this._penRect.y, this._penRect.width, this._penRect.height);
        
        /*
        const penGraphic = new PIXI.Sprite(PIXI.Texture.WHITE);
        penGraphic.tint = 0xf20f22;
        penGraphic.alpha = 0.5;
        penGraphic.x = this._pen.x;
        penGraphic.y = this._pen.y;
        penGraphic.width = this._pen.width;
        penGraphic.height = this._pen.height;
        this._npc.parent.addChild(penGraphic);

        const depositGraphic = new PIXI.Sprite(PIXI.Texture.WHITE);
        depositGraphic.tint = 0x1a97eb;
        depositGraphic.alpha = 0.5;
        depositGraphic.x = this._deposit.x;
        depositGraphic.y = this._deposit.y;
        depositGraphic.width = this._deposit.width;
        depositGraphic.height = this._deposit.height;
        this._npc.parent.addChild(depositGraphic);
        */
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();
        if (this.isRunning) {
            const chickenCount = this._allChickens.length;
            if (chickenCount < this._spawnLimit) {
                if (this._spawnTime > this._spawnDelay) {
                    this._spawnTime = 0;
                    this.spawnChicken(game);
                }
                this._spawnTime += window.dt;
            }
            if(game.player.testCollisionRectFastOld(this._deposit.x, this._deposit.y, this._deposit.width, this._deposit.height)){
                if(this._holdingChicken){
                    this._holdingChicken.state = definitions.ENEMY_STATE.IDLE;
                    this._holdingChicken.position = game.world.findSafePosition({x:this._pen.x + (this._pen.width/2), y:this._pen.y + (this._pen.height/2)}, 0, Math.min(this._pen.width, this._pen.height)/2);
                    this._holdingChicken.facingDirection = Math.random() > 0.5 ? 1 : -1;
                    this._holdingChicken.view.position.set(0);
                    this._holdingChicken.addChild(this._holdingChicken.view);
                    this._holdingChicken = null;
                    this._player.holdingObject = false;
                    this.score++;
                    if(this.score >= chickenCount){
                        game.completeMinigame(true)
                    }
                }
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        this.removeAllChickens(game);

        this._player.holdingObject = false;
        this._player.playIdleAnimation();

        this.bestScore = this.score;
        //console.log("score:", this.score);
    }

    onMinigameCancel(game) {
        super.onMinigameCancel(game);

        if(this._holdingChicken) {
            this._holdingChicken.state = definitions.ENEMY_STATE.RETREAT;
            this._holdingChicken.view.position.set(0);
            this._holdingChicken.addChild(this._holdingChicken.view);
            this._holdingChicken = null;
            this._player.holdingObject = false;
        }

        this.removeAllChickens(game);
    }
}